module.exports = __webpack_public_path__ + "media/images/puzzle/puzzle_104-781dbec231d7b8aea8312db8787216d0.png";